import { DataBean } from "../DataBean";


export class SiteID extends DataBean {

    public async getSiteIDByKey(idlnsite: number, state: number | null): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.site.SiteID_getSiteIDByKey_Number_Number", [idlnsite, state]);
    }

}